import { render, staticRenderFns } from "./CautionTemplate.vue?vue&type=template&id=41230e50&scoped=true&"
import script from "./CautionTemplate.vue?vue&type=script&lang=js&"
export * from "./CautionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CautionTemplate.vue?vue&type=style&index=0&id=41230e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41230e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41230e50')) {
      api.createRecord('41230e50', component.options)
    } else {
      api.reload('41230e50', component.options)
    }
    module.hot.accept("./CautionTemplate.vue?vue&type=template&id=41230e50&scoped=true&", function () {
      api.rerender('41230e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Caution/CautionTemplate.vue"
export default component.exports